<template>
    <div class="Admin_LoginPage_wrap">
        <div class="Admin_LoginPage_login">
            <AppConfirmDialog v-model="showConfirmationDialog" :title="confirmationTitle"
            :message="confirmationMessage" @confirm="handleConfirm" />
            <div class="Admin_LoginPage_login__shadow">
                    <div class="Admin_LoginPage_login__form">
                        <div class="Admin_LoginPage_login__form--input">
                            <div class="Admin_LoginPage_login__form--title">
                                <h1>관리자 로그인</h1>
                            </div>
                            <div class="Admin_LoginPage_login__form--input_email">
                                <label for="email">이메일</label>
                                <input v-model="email"  class="input_custom" placeholder="email" @blur="validateName" @keyup.enter="submitLogin"/>
                                <div class="input_custom__stste">
                                    <div v-if="nameError" class="input_custom__error">
                                        <v-icon class="mdi mdi-alert-circle-outline" x-small color="#ED2727" />
                                        <span class="input_custom__error_txt">{{ nameError }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="Admin_LoginPage_login__form--input_password">
                                <label for="password">비밀번호</label>
                                <input v-model="password" type="password" class="input_custom" placeholder="password" @blur="validatePassword" @keyup.enter="submitLogin"/>
                                <div class="input_custom__stste">
                                    <div v-if="passwordError" class="input_custom__error">
                                        <v-icon class="mdi mdi-alert-circle-outline" x-small color="#ED2727" />
                                        <span class="input_custom__error_txt">{{ passwordError }}</span>
                                    </div>
                                </div>
                            </div>
                            <v-btn  @click="submitLogin()" class="Admin_LoginPage_login__form--input_btn" block elevation="0" color="#414042" x-large :loading="loading">
                                로그인
                            </v-btn>
                        </div>
                        <div class="Admin_LoginPage_login__img--logo">
                            <img src="~@/assets/images/login_left_logo.png"/>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>
 
<script>

import { mapActions } from 'vuex';
import AppConfirmDialog from '@/components/app/AppConfirmDialog.vue';

export default {
    components: {
        AppConfirmDialog
    },
    data() {
        return {
            email: null,
            password: null,
            passwordError: null,
            nameError: null,
            confirmationMessage: null,
            confirmationTitle: null,
            showConfirmationDialog: false,
            loading: false,
        }
    },
    methods: {
        ...mapActions('admin', ['login']),
        submitLogin(){
            this.validatePassword();
            if (!this.nameError && !this.passwordError) {
                this.loading = true;
                this.login({email: this.email, password: this.password})
                    .then(() => {
                        localStorage.setItem("currentTab", 'tab-Item1');
                        this.$router.push({ path: '/admin_dashboard' });
                    })
                    .catch(error => {
                        this.showConfirmationDialog = true;
                        this.confirmationTitle = "로그인 실패";
                        this.confirmationMessage = error.response && error.response.data.message
                            ? error.response.data.message
                            : "로그인 과정에서 오류가 발생했습니다. 다시 시도해 주세요.";
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleConfirm() {
            this.showConfirmationDialog = false;
            this.email = '';
            this.password = '';
        },
        validateName() {
            // if (!this.name) {
            //     this.nameError = "이메일을 입력해주세요.";
            // } else {
            //     this.nameError = "";
            // }
        },
        validatePassword() {
            // if (!this.password) {
            //     this.passwordError = "비밀번호를 입력해주세요.";
            // } else if (this.password.length !== 4 || isNaN(this.password)) {
            //     this.passwordError = "비밀번호는 4자리 숫자로 입력해주세요.";
            // } else {
            //     this.passwordError = "";
            // }
        },
    }
}
</script>

<style scoped>

</style>